import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';

Swiper.use([Navigation]);

const GalleryPlanPhotoSlideshow = () => {
    const slideshowEls = document.querySelectorAll<HTMLElement>(
        '.js-gallery-plan-slideshows',
    );

    if (slideshowEls.length === 0) {
        console.warn('Slideshows not found');
        return;
    }

    const getAnimationType = () => {
        const width = window.innerWidth;
        if (width < 1024) return 'tablet'; // Tablet Down
        return 'desktop'; // Desktop
    };

    const slidesPer = getAnimationType() === 'tablet' ? 1 : 1.5;

    const filterSlides = (swiper: Swiper, keywords: string[]): void => {
        const slides = swiper.slides as HTMLElement[]; // Get the slides from the Swiper instance
        const visibleSlides: HTMLElement[] = []; // Track visible slides

        // Filter slides based on keywords
        slides.forEach((slide: HTMLElement) => {
            const category = slide.dataset.category || ''; // Handle undefined cases
            const containsAnyKeyword = keywords.some(keyword => category.includes(keyword));

            if (containsAnyKeyword || keywords.length === 0) {
                slide.style.display = ''; // Show slide
                visibleSlides.push(slide); // Add to visible slides list
            } else {
                slide.style.display = 'none'; // Hide slide
            }
        });

        swiper.updateSlides(); // Update slides after filtering
        swiper.update(); // Reinitialize swiper to account for new slide layout

        const shouldLoop = visibleSlides.length > 3; // Enable loop if 3 or more slides are visible
        console.log(shouldLoop);
        swiper.params.loop = shouldLoop; // Dynamically set loop
        swiper.loopDestroy(); // Destroy existing loop behavior
        swiper.loopCreate(); // Recreate loop behavior with new setting

        // Reapply Swiper active/prev/next classes to visible slides only
        if (visibleSlides.length > 0) {

            console.log(visibleSlides.length, 'vsl');
            let activeIndex = 0;

            if (visibleSlides.length == 3) {
                activeIndex = 0; // Center the active slide
            } else if (visibleSlides.length > 3) {
                activeIndex = Math.floor(visibleSlides.length / 2)
            }

            const activeSlide = visibleSlides[activeIndex];

            visibleSlides.forEach((slide, index) => {
                slide.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev');

                if (index === activeIndex) {
                    slide.classList.add('swiper-slide-active');
                } else if (index === activeIndex + 1) {
                    slide.classList.add('swiper-slide-next');
                } else if (index === activeIndex - 1) {
                    slide.classList.add('swiper-slide-prev');
                }
            });

            const newActiveIndex = swiper.slides.indexOf(activeSlide);

            swiper.slideTo(newActiveIndex, 0, false); // Jump to the active slide without animation
        }

        // Toggle navigation buttons based on visible slide count
        const nextButton = swiper.navigation?.nextEl as HTMLElement;
        const prevButton = swiper.navigation?.prevEl as HTMLElement;
        if (visibleSlides.length <= 1) {
            nextButton.style.display = 'none'; // Hide next button
            prevButton.style.display = 'none'; // Hide prev button
        } else {
            nextButton.style.display = ''; // Show next button
            prevButton.style.display = ''; // Show prev button
        }

        swiper.updateSlidesClasses(); // Update classes to ensure Swiper's internal state is correct
    };




    let selectedCategories: string[] = [];

    const handleFilterButtonClick = (event: Event, swiper: Swiper) => {
        const target = event.target as HTMLElement;
        const filter = target.dataset.target;

        if (!filter) return;

        // Clear previous selections
        document.querySelectorAll('.js-btn-gallery-filter').forEach(btn => btn.classList.remove('active'));

        // If the clicked button is "All", reset selectedCategories
        if (filter === 'all') {
            selectedCategories = []; // Reset to show all slides
            target.classList.add('active'); // Highlight "All Photos" button
        } else {
            selectedCategories = [filter]; // Set the single category as selected
            target.classList.add('active'); // Highlight the clicked button
        }

        filterSlides(swiper, selectedCategories); // Filter slides based on the single selected category
    };

    const init = () => {
        slideshowEls.forEach(swiperElement => {
            const parentElement = swiperElement.closest('.js-gallery-plan-slideshow-container')!;

            const nextButton = parentElement.querySelector('.js-btn-slideshow-next') as HTMLElement;
            const prevButton = parentElement.querySelector('.js-btn-slideshow-prev') as HTMLElement;

            // Get the initial number of slides that are visible (not filtered)
            const initialSlides = swiperElement.querySelectorAll('.swiper-slide:not([style*="display: none"])');
            const shouldLoop = initialSlides.length >= 3; // Disable loop if fewer than 3 slides

            const options: SwiperOptions = {
                slidesPerView: slidesPer, // Show a portion of the next and previous slides
                centeredSlides: true,
                spaceBetween: 10,
                loop: shouldLoop, // Dynamically set loop based on the number of slides
                slideToClickedSlide: true,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
            };

            const swiper = new Swiper(swiperElement, options);
            swiper.update();

            // Check the number of slides and hide navigation if there are fewer than 2
            if (swiper.slides.length < 2) {
                nextButton.style.display = 'none';
                prevButton.style.display = 'none';
            }

            // Event listeners for filtering
            const filterButtons = parentElement.querySelectorAll('.js-btn-gallery-filter');
            filterButtons.forEach(button => {
                button.addEventListener('click', event => handleFilterButtonClick(event, swiper));
            });
        });
    };


    init();
};

export default GalleryPlanPhotoSlideshow;
